import '../../../icons'
import Password from '../../component/inputs/password/index'
import Button from '../../component/buttons/button/index'
import axios from 'axios'
import Close from '../../component/close/index'

export default {
  name: 'AccountRecovery',
  inject: ['validator'],

  data () {
    return {
      form: {
        token: this.$route.query.token,
        password: ''
      },
      isLoading: false,
      passwordChanged: false,
      serverValidationError: false,
      serverValidationErrorMessage: '',
      lang: this.$route.params.lang
    }
  },
  components: {
    'kw-password': Password,
    'kw-button': Button,
    'kw-close' : Close
  },
  computed: {
    isFormValid () {
      if (this.errors.items.length !== 0 || this.form.email === '') {
        return true
      } else {
        return false
      }
    }
  },
  created () {
  },
  methods: {

    sendEmail () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.isLoading = true

          axios.post(`${process.env.API_URL}/user/reset-password/set-password`, this.form, {
            withCredentials: 'true',
            credentials: 'same-origin'
          })
            .then(({data}) => {
              this.isLoading = false
              if (!data.valid) {
                this.serverValidationErrorMessage = data.error
                this.passwordChanged = false
                this.serverValidationError = true

                return
              }
              this.passwordChanged = true
              this.isLoading = false
              // if is good redirect
            }).catch((error) => {
            this.serverValidationErrorMessage = error
            this.isLoading = false
          })
        }
      })
    },
    removeMessage () {
      this.serverValidationError = false
    },
    redirect () {
      let url = `/${this.lang}`

      window.location.replace(url)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/views/ResetPassword/ResetPassword.js